import React from 'react';
import { CTAButton } from './CTAButton';
export function WoundSection() {
  return <section className="bg-warm-white py-[100px] px-5" data-id="element-589">
      <div className="max-w-[680px] mx-auto flex flex-col" data-id="element-590">
        <p className="font-serif text-[22px] text-primary-dark leading-[1.9] mb-8" data-id="element-591">
          It's Sunday night. The house is quiet. Everyone else is asleep.
          <br data-id="element-592" />
          <br data-id="element-593" />
          You're at the kitchen table — or in bed with your phone — and you're
          doing the math again.
        </p>

        <div className="bg-cream-light border-l-[4px] border-gold-accent p-6 md:p-8 mb-10 overflow-x-auto" data-id="element-594">
          <pre className="font-mono text-[14px] md:text-[16px] leading-relaxed text-primary-dark whitespace-pre-wrap" data-id="element-595">
            <div className="flex justify-between mb-1" data-id="element-596">
              <span data-id="element-597">Credit card payment ............ DUE FRIDAY</span>
              <span className="text-blood-red" data-id="element-598">$150</span>
            </div>
            <div className="flex justify-between mb-1" data-id="element-599">
              <span data-id="element-600">Car insurance auto-pay ......... HITS WEDNESDAY</span>
              <span className="text-blood-red" data-id="element-601">$89</span>
            </div>
            <div className="flex justify-between mb-4" data-id="element-602">
              <span data-id="element-603">Groceries + gas (estimate) ..... THIS WEEK</span>
              <span className="text-blood-red" data-id="element-604">$140</span>
            </div>
            <div className="text-primary-dark/30 mb-4" data-id="element-605">
              ──────────────────────────────────────────────────────
            </div>
            <div className="flex justify-between mb-2 font-bold" data-id="element-606">
              <span data-id="element-607">TOTAL NEEDED THIS WEEK:</span>
              <span className="text-blood-red" data-id="element-608">$379</span>
            </div>
            <div className="flex justify-between font-bold text-[18px] md:text-[20px]" data-id="element-609">
              <span data-id="element-610">CURRENT BALANCE:</span>
              <span className="text-blood-red" data-id="element-611">$42</span>
            </div>
          </pre>
        </div>

        {/* Emotional scene image */}
        <div className="my-10 max-w-[680px] mx-auto rounded-lg overflow-hidden shadow-[0_8px_30px_rgba(0,0,0,0.12)]" data-id="element-612">
          <img src="https://cdn.magicpatterns.com/uploads/7CVJz5hF11Sye2RkLrciQW/heylloyd-image-1774829811972.png" alt="Checking bank balance late at night — the feeling everyone knows" className="w-full h-auto block" data-id="element-613" />
        </div>

        <p className="font-serif text-[20px] text-primary-dark leading-[1.9] mb-6" data-id="element-614">
          Your stomach drops.
          <br data-id="element-615" />
          <br data-id="element-616" />
          Your mind starts calculating.
        </p>

        <p className="font-serif text-[20px] text-primary-dark/80 italic leading-[1.9] mb-8 pl-4 border-l-2 border-primary-dark/10" data-id="element-617">
          Can I push the minimum this month?
          <br data-id="element-618" />
          Maybe I put gas on the other card.
          <br data-id="element-619" />
          Maybe if I just get through this week...
        </p>

        <p className="font-serif text-[20px] text-primary-dark leading-[1.9] mb-10" data-id="element-620">
          You run the numbers six different ways.
        </p>

        <div className="text-center mb-10" data-id="element-621">
          <h3 className="font-serif text-[28px] font-bold text-primary-dark inline-block border-b-2 border-gold-accent pb-1" data-id="element-622">
            None of them work.
          </h3>
        </div>

        <p className="font-serif text-[20px] text-primary-dark leading-[1.9] mb-6 text-center" data-id="element-623">
          And the worst part isn't the math.
          <br data-id="element-624" />
          It's the FEELING.
        </p>

        <p className="font-sans text-[18px] text-primary-dark leading-[2] mb-12" data-id="element-625">
          That tightness in your chest that starts Sunday afternoon. The 2 AM
          thought spiral that wakes you for no reason except that your brain
          refuses to stop calculating. The low hum of financial dread that runs
          underneath every good moment — your kid's birthday, dinner with
          friends, every vacation you didn't take because you couldn't justify
          it.
        </p>

        <div className="py-8 border-y border-gold-accent text-center mb-8" data-id="element-626">
          <h4 className="font-serif italic text-[26px] text-primary-dark mb-4" data-id="element-627">
            This is the Gas Moment.
          </h4>
          <p className="font-serif text-[20px] text-primary-dark leading-[1.6]" data-id="element-628">
            That instant when you look at your financial life and realize the
            tank is empty — but you're still miles from the next station.
          </p>
        </div>

        <p className="font-sans text-[16px] text-primary-dark/60 italic text-center mb-10" data-id="element-629">
          If you've felt this, you're not weak. You're not failing.
          <br data-id="element-630" />
          You're not alone. You're the majority.
        </p>

        <p className="font-serif text-[20px] font-bold text-gold-accent text-center mb-10" data-id="element-631">
          And nobody gave you a system to fix it. Until now.
        </p>

        <div className="flex justify-center" data-id="element-632">
          <CTAButton subText="The system that replaces Sunday dread with control" data-id="element-633">
            YES — SHOW ME THE SYSTEM → $9.99
          </CTAButton>
        </div>
      </div>
    </section>;
}